
const features = {
    //viewsets from django
    category: 'category',
    test_taker: "test_taker",
    score_method: "score_method",
    battery: "battery",
    user_role: "user_role",
    learning_center: 'learning_center',
    admin_assessment: "admin_assessment",

    school_setup: "school_setup",

    assessments: "assessments",
    test_takers: "test-takers",
    all_assessments: "perform-assessments",
    tutorials: "tutorials",
    general_performance_review: "general_performance_review",

    // columns in table
    training_assessment: "training_assessment",
    view_assessment_def: "view_assessment_def",

    assessment_library: "assessment-library",
    id_cell: "id_cell",
    create_date_cell: "create_date_cell",
    user_password: "user_password",
    download_audio: "download_audio",
    redo_assessment: "redo_assessment",

    transcription_system: "transcription_system",

    practicate_assessments: "practicate_assessments",

    reading_quality_cell: "reading_quality_cell",

    assessments_activity__tab: "assessments_activity__tab"
}



export default features